// Libs
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
// App
import { SWR_DEFAULT_CONFIG } from './swr-default-config.constants';

/**
 * Bring swr and axios together for get requests
 * @see : Inspired from https://github.com/vercel/swr/issues/143
 * @param url the url for request
 * @param config the swr config
 */
export const useSWRAxiosGetRequest = <Data = unknown, Error = unknown>(
  urlOptional: string | null,
  SWRConfig?: SWRConfiguration,
  axiosConfig?: AxiosRequestConfig
): SWRResponse<Data, AxiosError<Error>> => {
  return useSWR<Data, AxiosError<Error>>(
    urlOptional,
    () => axios.get(urlOptional, axiosConfig).then((response) => response.data),
    { ...SWR_DEFAULT_CONFIG, ...SWRConfig }
  );
};
